import React from "react";
import "../summary_sheet/css/purchase_analysis_by_term.scss";
import { useDocument } from "../loan_tool";
import { useUser } from "../../../hooks/user";
import Image from "../../ui/image";
import PhoneField from "../../fields/phone_field";
import DateField, { today } from "../../fields/date_field";
import { borrower_names } from "../../../constants/utils";

export default function FixAndFlipPrintHeader({ pageTitle }) {
  const [{ companyProfile }] = useUser();
  const [document, , { documentAccountProfile }] = useDocument();

  const borrowers = (document.applicant && document.applicant.borrowers) || [];
  const borrowerNames = borrower_names(borrowers);
  const firstBorrower = borrowers[0] || {};
  const loName = [documentAccountProfile.first_name, documentAccountProfile.last_name]
    .filter(Boolean).join(" ");

  const { property } = document;

  return (
    <div className="ff-print-header">
      {/* Reuses the same pa-* CSS classes as Total Cost Analysis — identical look */}
      <div className="pa-header">
        <div className="pa-logo">
          <Image className="company-logo" url="company/company-logo" />
        </div>

        <div className="pa-borrower-info">
          <div className="pa-section-label">CLIENT(S)</div>
          <div className="pa-borrower-grid">
            <div className="pa-borrower-col">
              {borrowerNames[0] && <div className="pa-name">{borrowerNames[0]}</div>}
              {borrowerNames[1] && <div className="pa-name">{borrowerNames[1]}</div>}
            </div>
            {(borrowerNames[2] || borrowerNames[3]) && (
              <div className="pa-borrower-col">
                {borrowerNames[2] && <div className="pa-name">{borrowerNames[2]}</div>}
                {borrowerNames[3] && <div className="pa-name">{borrowerNames[3]}</div>}
              </div>
            )}
          </div>
          {property && property.address && (
            <div className="pa-addr">{[property.address, property.address2].filter(Boolean).join(" ")}</div>
          )}
          {property && (property.city || property.state) && (
            <div className="pa-addr">
              {[property.city, property.state].filter(Boolean).join(", ")}
              {property.zip ? " " + property.zip : ""}
            </div>
          )}
        </div>

        <div className="pa-lo-dates">
          <div className="pa-lo-info">
            {loName && <div className="pa-lo-name">{loName}</div>}
            {documentAccountProfile.nmls_number && (
              <div>NMLS #: {documentAccountProfile.nmls_number}</div>
            )}
            {documentAccountProfile.state_real_estate_license && (
              <div>Lic #: {documentAccountProfile.state_real_estate_license}</div>
            )}
            {documentAccountProfile.cell_phone && (
              <div className="pa-phone-row">
                Cell: <PhoneField naked value={documentAccountProfile.cell_phone} />
              </div>
            )}
            {documentAccountProfile.office_phone && (
              <div className="pa-phone-row">
                Office: <PhoneField naked value={documentAccountProfile.office_phone} />
              </div>
            )}
            {documentAccountProfile.email && (
              <div>{documentAccountProfile.email}</div>
            )}
          </div>
          <div className="pa-dates">
            <div>
              <span className="pa-date-label">DATE ISSUED:</span>
              <DateField naked value={today()} />
            </div>
          </div>
        </div>
      </div>

      <div className="pa-title-block">
        <div className="pa-title">Fix and Flip Estimator — {pageTitle}</div>
      </div>
    </div>
  );
}
